module.exports = __webpack_public_path__ + "img/3.b490a8e3.png";